import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { WalletService } from '../../../../services/wallet/wallet.service';
import { DelegateService } from '../../../../services/delegate/delegate.service';
import { ModalComponent } from '../../../modals/modal.component';
import { InputValidationService } from '../../../../services/input-validation/input-validation.service';
import { MessageService } from '../../../../services/message/message.service';
import { Subscription } from 'rxjs';
import { take } from 'rxjs/operators';
import { SubjectService } from '../../../../services/subject/subject.service';
import { CONSTANTS as _CONSTANTS } from '../../../../../environments/environment';

@Component({
  selector: 'app-delegate-page',
  templateUrl: './delegate-page.component.html',
  styleUrls: ['../../../../../scss/components/views/logged-in/delegate/delegate.component.scss']
})
export class DelegatePageComponent implements OnInit, OnDestroy {
  delegates;
  activeAccount = null;
  customAddress: string = '';
  isShowingCustom = false;
  balanceXTZ = 0;
  private subscriptions: Subscription = new Subscription();
  CONSTANTS = _CONSTANTS;
  isMobile = false;
  constructor(
    public delegateService: DelegateService,
    public router: Router,
    public walletService: WalletService,
    public inputValidationService: InputValidationService,
    private messageService: MessageService,
    private subjectService: SubjectService
  ) {
    this.subscriptions.add(
      this.subjectService.activeAccount.subscribe((activeAccount) => {
        if (this.activeAccount !== activeAccount) {
          this.activeAccount = activeAccount;
          this.balanceXTZ = this.activeAccount ? this.activeAccount.balanceXTZ / 1000000 : 0;
          this.subscriptions.add(
            this.delegateService.delegates.pipe(take(1)).subscribe((d) => {
              this.delegates = this.filter(d);
            })
          );
        }
      })
    );

    this.subscriptions.add(
      this.delegateService.delegates.subscribe((d) => {
        this.balanceXTZ = this.activeAccount ? this.activeAccount.balanceXTZ / 1000000 : 0;
        this.delegates = this.filter(d);
      })
    );
  }

  ngOnInit(): void {
    const mobileCheck = () => {
      this.isMobile = !!parseInt(document.documentElement.style.getPropertyValue('--is-mobile'));
    };
    window.addEventListener('resize', mobileCheck);
    mobileCheck();
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  filter(delegates: any): any[] | null {
    if (delegates?.length) {
      const del = delegates.filter((d) => {
        try {
          if (
            d.delegation.estimatedApy >= 0 &&
            d.delegation.enabled &&
            d.delegation.freeSpace >= this.balanceXTZ &&
            d.status == 'active' // other options: closed, not_responding
          ) {
            return d;
          }
        } catch {
          return;
        }
      });
      const d2 = del.filter((d) => d.delegation.freeSpace < this.balanceXTZ).sort((a, b) => b.delegation.freeSpace - a.delegation.freeSpace);
      const d1 = del.filter((d) => d.delegation.freeSpace >= this.balanceXTZ).sort((a, b) => b.delegation.estimatedApy - a.delegation.estimatedApy);
      return [...d1, ...d2].sort((x, y) => (x.address === this.activeAccount?.delegate ? -1 : y === this.activeAccount?.delegate ? 1 : 0));
    }
    return [];
  }
  stake(delegate: any): void {
    if (delegate.address === '' || (this.inputValidationService.validDelegationAddress(delegate.address) && delegate.address !== this.activeAccount.address)) {
      ModalComponent.currentModel.next({
        name: 'delegate-confirm',
        data: delegate
      });
    } else {
      this.messageService.addError(`Invalid baker address: ${delegate?.address}`);
    }
  }

  round(val): string {
    return Math.round(Number(val)).toString();
  }

  toPercent(val): string {
    return parseFloat((Number(val) * 100).toFixed(2)).toString() + '%';
  }

  toggleCustom(): void {
    this.isShowingCustom = this.isShowingCustom ? false : true;
  }
}
